import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import Accordion from "react-bootstrap/Accordion"
import Card from "react-bootstrap/Card"
import Button from "react-bootstrap/Button"
import Layout from "../components/Layout"
import BannerGraphics from "../components/BannerGraphics"
import WebHelmet from "../seo/WebHelmet"
import PageMeta from "../seo/pageMeta"
import Fade from "react-reveal/Fade"
import "../css/faq.scss"

const faqData = [
    {
        title: "Is is legal to have an electronic signature?",
        body: "Yes. The ESIGN act of 2000 allows for electronic signatures on documents. For the I-9, we are in compliance with the guidance from US Citizenship and Immigration Service published in their Handbook for Employers M-274, Chapter 10.3.2. For the W-4, we are compliant with all of the requirements CFR-CFR - §31.3402(f)(5)-1(c).",
    }, {
        title: "How does it read documents?",
        body: "All drivers licenses in the US have a PDF417 barcode on the back. That helps us get a persons name, address, and other information to identify them. Many other documents like visas, passports, permanent resident cards (including MICA / Green Card) have MRZ or machine readable zones. Other documents like a social security card have a number that is always in the same format. We scan the documents with the cell phone camera and use machine learning systems to read it. If a document is damaged or the camera can’t read it, you can still manually enter the data from the document.",
    }, {
        title: "Does it handle other employment forms?",
        body: "Yes! You can upload any existing PDF document to the system that has form fields and firstDay can those out as well.",
    }, {
        title: "How long does it take to setup?",
        body: "Under a minute to setup to fill out I-9 and W-4. It will take 5 to 10 minutes for each additional document template you want to add. We publish a free API to integrate with your payroll system. If your payroll vendor needs help, we can help them on a time and material basis.",
    }, {
        title: "How secure is it?",
        body: "All documents and signatures are encrypted using AES-256 encryption on Amazon S3 servers. All communications occur over secure encryption.",
    },
]

const FAQ = (props) => {
    const [activeThis, setActiveThis] = React.useState(0)
    const FAQItems = faqData.map((item, index) => {
        return (
            <Card key={"question" + index}>
                <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey={"faq" + index}
                                      className={"text-left text-dark w-100 " + (activeThis === index ? "" : " collapsed")}
                                      onClick={() => {
                                          setActiveThis(index)
                                      }}
                    >
                        <span className="d-flex font-weight-500">
                            <span className="h3 mb-0 text-primary mr-3">{"0" + (index + 1) + "."}</span>
                            <span className="h4 mb-0">{item.title}</span>
                        </span>
                    </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey={"faq" + index}>
                    <Card.Body className="text-muted ml-auto">{item.body}</Card.Body>
                </Accordion.Collapse>
            </Card>
        )
    })
    return (
        <Layout>
            <WebHelmet title={PageMeta.Title.FAQ} description={PageMeta.Desc.FAQ}/>
            <BannerGraphics showText={false}/>
            <Container>
                <Row className="justify-content-center py-5">
                    <Col md={10} xs={12}>
                        <section className="faq-section">
                            <Fade>
                                <Accordion defaultActiveKey="faq0">
                                    {FAQItems}
                                </Accordion>
                            </Fade>
                        </section>
                    </Col>
                </Row>
            </Container>
        </Layout>
    )
}

export default FAQ